var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNutrition(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25048_20869",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25048_20869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 16.668H11.667V15.7513L12.7087 15.3346C13.6114 14.9735 14.3788 14.4701 15.0107 13.8242C15.6427 13.1784 16.0975 12.4596 16.3753 11.668H3.62533C3.9031 12.4596 4.35449 13.1784 4.97949 13.8242C5.60449 14.4701 6.37533 14.9735 7.29199 15.3346L8.33366 15.7513V16.668ZM6.66699 18.3346V16.8763C5.18088 16.293 3.97602 15.3902 3.05241 14.168C2.1288 12.9457 1.66699 11.5569 1.66699 10.0013H3.33366V3.33464L18.3337 1.66797V2.91797L8.75033 4.0013V5.41797H18.3337V6.66797H8.75033V10.0013H18.3337C18.3337 11.5569 17.8719 12.9457 16.9482 14.168C16.0246 15.3902 14.8198 16.293 13.3337 16.8763V18.3346H6.66699ZM6.66699 5.41797H7.50033V4.1263L6.66699 4.23047V5.41797ZM4.58366 5.41797H5.41699V4.3763L4.58366 4.45964V5.41797ZM6.66699 10.0013H7.50033V6.66797H6.66699V10.0013ZM4.58366 10.0013H5.41699V6.66797H4.58366V10.0013Z",
    fill: "#74788D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutrition);
export default __webpack_public_path__ + "static/media/nutrition.fd9a3070d1243a158fe64f21a6d1caa0.svg";
export { ForwardRef as ReactComponent };